module.exports = __webpack_public_path__ + "static/media/cert_AUA_UD.843a1605.jpg";